import { Calculator, Box, BarChart3, Loader } from "lucide-react";
import { useFile } from "../context/filecontext";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { calcOreDillution } from "../calculations/oreDillution";
import { GetOreDillution } from "./overUnderBreak/getOreDillution";

const ResultDisplay = ({ label, value, unit }) => {
  console.log(value, "v");

  let fValue = "-"; // Default value if invalid

  if (typeof value === "number" && !isNaN(value)) {
    fValue = value.toFixed(2);
    console.log(fValue, "ff");
  } else {
    console.warn("Invalid value received:", value);
  }

  return (
    <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg">
      <span className="text-slate-600">{label}</span>
      <span className="font-medium text-slate-800">
        {typeof value === "number" && !isNaN(value) ? `${fValue} ${unit}` : "-"}
      </span>
    </div>
  );
};

const AnalysisTools = ({
  isCalculating,
  measurements,
  uploadResponse,
  onCalculate,
  selectedBlasts = [],
}) => {
  // const [currentMeasurements, setCurrentMeasurements] = useState({
  //   volume: { totalVolume: 0, surfaceArea: 0 },
  //   overbreak: { volume: 0, percentage: 0, maxLength: 0 },
  //   underbreak: { volume: 0, percentage: 0, maxLength: 0 },
  //   density: { pointDensity: 0, coverage: 0 },
  //   plannedDesignVolume : {
  //     volume : 0,
  //   },
  //   oreDillution : 0,
  // });
  const { currentMeasurements, setCurrentMeasurements } = useFile();
  // const defaultMeasurements =

  // const defaultMeasurements = {
  //   volume: { totalVolume: 0, surfaceArea: 0 },
  //   overbreak: { volume: 171.52, percentage: 6.8, maxDepth: 0 },
  //   underbreak: { volume: 216.79, percentage: 8.82, maxDepth: 0 },
  //   density: { pointDensity: 0, coverage: 0 }
  // };

  // const currentMeasurements =  defaultMeasurements;
  // const currentMeasurements = measurements || defaultMeasurements;
  const canCalculate = selectedBlasts && selectedBlasts.length > 0;

  const handleCalculateClick = async () => {
    if (canCalculate && onCalculate) {
      // let volumeData = {volume : 5555555}
      let volumeData = await onCalculate(selectedBlasts);
      window.designVolume = volumeData?.volume;
      setTimeout(() => {
        let newMeasurements = {
          ...currentMeasurements,
          volume: { totalVolume: 0, surfaceArea: 0 },
          overbreak: { volume: 171.52, percentage: 6.8, maxLength: 1.5 },
          underbreak: { volume: 216.79, percentage: 8.82, maxLength: 0.76 },
          density: { pointDensity: 0, coverage: 0 },
          plannedDesignVolume: {
            volume: 2456.99,
          },
        };
        newMeasurements.oreDillution = calcOreDillution(
          volumeData?.volume,
          newMeasurements.plannedDesignVolume.volume,
          newMeasurements.underbreak.volume
        );
        // setCurrentMeasurements(newMeasurements);
        measurements((prev) => ({
          ...prev,
          overbreak: { volume: 171.52, percentage: 6.8, maxLength: 1.5 },
          underbreak: { volume: 216.79, percentage: 8.82, maxLength: 0.76 },
          density: { pointDensity: 0, coverage: 0 },
          plannedDesignVolume: {
            volume: 2456.99,
          },
          oreDillution: newMeasurements.oreDillution,
        }));
        localStorage.setItem("scanresult", JSON.stringify(newMeasurements));
        let backendUrl = process.env.REACT_APP_BACKEND_URL;
        let glbUrl = `${backendUrl}/get-glb/?las_path_aws=`;
        let getOreDillution = new GetOreDillution({
          designLasUrl:
            glbUrl +
            "https://private-bucket-mine.s3.ap-south-1.amazonaws.com/Files/c3VzaGls/flat-design/preprocessfiles/556_N_BH4_B4.las",
          actualLasUrl:
            glbUrl +
            "https://private-bucket-mine.s3.ap-south-1.amazonaws.com/Files/merge-back.las",
          // actualLasUrl: glbUrl + "https://private-bucket-mine.s3.ap-south-1.amazonaws.com/Files/merge-wall.las",
          // states: gStates,
        });

        getOreDillution.init();
      }, 0);
    }
  };

  return (
    <>
      <div className="shrink-0 px-6 py-4 bg-slate-800 text-white">
        <h2 className="text-lg font-semibold">Analysis Tools</h2>
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="sticky top-0 z-10 bg-white p-6 border-b border-slate-200">
          <button
            onClick={handleCalculateClick}
            disabled={isCalculating || !canCalculate}
            className={`w-full py-3 px-4 rounded-lg font-medium
              flex items-center justify-center gap-2 transition-colors
              ${
                isCalculating
                  ? "bg-slate-400 text-white cursor-not-allowed"
                  : !canCalculate
                  ? "bg-slate-100 text-slate-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700 text-white"
              }`}
          >
            {isCalculating ? (
              <>
                <Loader className="w-5 h-5 animate-spin" />
                Calculating...
              </>
            ) : (
              <>
                <Calculator className="w-5 h-5" />
                {!canCalculate ? (
                  <>Select Blast Data to Calculate</>
                ) : (
                  <>
                    Perform Calculations ({selectedBlasts.length} blast
                    {selectedBlasts.length !== 1 ? "s" : ""} selected)
                  </>
                )}
              </>
            )}
          </button>
        </div>

        <div className="p-6 space-y-6">
          {/* Volume Results */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Box className="w-5 h-5 text-slate-500" />
              <h2 className="text-lg font-semibold text-slate-800">
                Volume Analysis
              </h2>
            </div>
            <div className={`space-y-3 ${!canCalculate && "opacity-50"}`}>
              <ResultDisplay
                label="Actual Volume"
                value={uploadResponse?.volume || 0}
                unit="m³"
              />
              <ResultDisplay
                label="Planned design Volume"
                value={currentMeasurements?.plannedDesignVolume?.volume || 0}
                unit="m³"
              />
              {/* 2456.99 */}
              {/* <ResultDisplay
                label="Surface Area"
                value={uploadResponse?.volume?.surfaceArea}
                unit="m²"
              /> */}
            </div>
          </div>

          {/* Overbreak Results */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <BarChart3 className="w-5 h-5 text-slate-500" />
              <h2 className="text-lg font-semibold text-slate-800">
                Overbreak Analysis
              </h2>
            </div>
            <div className={`space-y-3 ${!canCalculate && "opacity-50"}`}>
              <ResultDisplay
                label="Volume"
                value={currentMeasurements.overbreak.volume}
                unit="m³"
              />
              <ResultDisplay
                label="Percentage"
                value={currentMeasurements.overbreak.percentage}
                unit="%"
              />
              <ResultDisplay
                label="Max Length"
                value={currentMeasurements.overbreak.maxLength}
                unit="m"
              />
            </div>
          </div>

          {/* Underbreak Results */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <BarChart3 className="w-5 h-5 text-slate-500" />
              <h2 className="text-lg font-semibold text-slate-800">
                Underbreak Analysis
              </h2>
            </div>
            <div className={`space-y-3 ${!canCalculate && "opacity-50"}`}>
              <ResultDisplay
                label="Volume"
                value={currentMeasurements.underbreak.volume}
                unit="m³"
              />
              <ResultDisplay
                label="Percentage"
                value={currentMeasurements.underbreak.percentage}
                unit="%"
              />
              <ResultDisplay
                label="Max Length"
                value={currentMeasurements.underbreak.maxLength}
                unit="m"
              />
            </div>
          </div>

          {/* Point Density Results */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Box className="w-5 h-5 text-slate-500" />
              <h2 className="text-lg font-semibold text-slate-800">
                Ore Dillution
              </h2>
            </div>
            <div className={`space-y-3 ${!canCalculate && "opacity-50"}`}>
              <ResultDisplay
                label="Ore Dillution"
                value={currentMeasurements.oreDillution}
                unit="%"
              />
            </div>
          </div>

          {/* Point Density Results */}
          {/* <div>
            <div className="flex items-center gap-2 mb-4">
              <Box className="w-5 h-5 text-slate-500" />
              <h2 className="text-lg font-semibold text-slate-800">Point Density Analysis</h2>
            </div>
            <div className={`space-y-3 ${!canCalculate && 'opacity-50'}`}>
              <ResultDisplay
                label="Point Density"
                value={currentMeasurements.density.pointDensity}
                unit="pts/m²"
              />
              <ResultDisplay
                label="Surface Coverage"
                value={currentMeasurements.density.coverage}
                unit="%"
              />
            </div>
          </div> */}

          {/* Additional Information */}
          <div className="pt-4 border-t border-slate-200">
            <div className="text-sm text-slate-500">
              <p className="mb-2">
                * All measurements are calculated based on selected blast data
              </p>
              <p>* Point density calculations consider surface orientation</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

AnalysisTools.propTypes = {
  isCalculating: PropTypes.bool,
  isCalculationEnabled: PropTypes.bool,
  measurements: PropTypes.object,
  uploadResponse: PropTypes.object,
  onCalculate: PropTypes.func,
  selectedBlasts: PropTypes.array,
};

export default AnalysisTools;
